import AccountSync from "../services/AccountSync.js";

/**
 * Révision espacée des erreurs (17 du TODO), en boîtes de Leitner.
 *
 * Chaque faute sur un drapeau ou une capitale, dans n'importe quel mode, place
 * le pays en boîte 0 de la compétence concernée : à revoir tout de suite. Une
 * bonne réponse en révision le fait monter d'une boîte, et l'intervalle avant
 * la prochaine révision s'allonge (1, 3, 7 puis 16 jours) ; une erreur le
 * renvoie en boîte 0. Au-delà de la dernière boîte, le pays est acquis.
 *
 * `geonerd.review` = `{ flag|capital: { code: { box, due, t } } }` : `due` est
 * l'échéance (ms), `t` la dernière mise à jour, qui départage la fusion entre
 * appareils (synchronisé). Commun aux deux langues.
 */
export const KEY = "geonerd.review";
export const SKILLS = ["flag", "capital"];
const DAY = 86400000;
/** Délai avant la prochaine révision, selon la boîte atteinte. */
export const INTERVALS = [0, DAY, 3 * DAY, 7 * DAY, 16 * DAY];
export const MASTERED_BOX = INTERVALS.length;

export function read() {
	try {
		const raw = JSON.parse(localStorage.getItem(KEY) || "{}");
		return raw && typeof raw === "object" ? raw : {};
	} catch (e) {
		return {};
	}
}

function write(deck) {
	localStorage.setItem(KEY, JSON.stringify(deck));
	AccountSync.scheduleSync();
}

/** Une faute en partie : le pays passe (ou repasse) en boîte 0, à revoir maintenant. */
export function recordMiss(skill, code, now = Date.now()) {
	if (!SKILLS.includes(skill) || !code) return;
	const deck = read();
	deck[skill] = deck[skill] || {};
	deck[skill][code] = { box: 0, due: now, t: now };
	write(deck);
}

/** Résultat d'une carte en révision. */
export function recordReview(skill, code, correct, now = Date.now()) {
	const deck = read();
	const entry = deck[skill]?.[code];
	if (!entry) return null;
	const box = correct ? Math.min(entry.box + 1, MASTERED_BOX) : 0;
	const due = box >= MASTERED_BOX ? null : now + INTERVALS[box];
	deck[skill][code] = { box, due, t: now };
	write(deck);
	return deck[skill][code];
}

/** Cartes à revoir maintenant, les plus en retard d'abord : `[{ skill, code }]`. */
export function dueCards(now = Date.now(), deck = read()) {
	const cards = [];
	for (const skill of SKILLS) {
		for (const [code, entry] of Object.entries(deck[skill] || {})) {
			if (entry && entry.box < MASTERED_BOX && typeof entry.due === "number" && entry.due <= now) {
				cards.push({ skill, code, due: entry.due });
			}
		}
	}
	return cards.sort((a, b) => a.due - b.due);
}

/** Bilan : à revoir, en cours, acquis, et prochaine échéance future. */
export function stats(now = Date.now(), deck = read()) {
	let due = 0, learning = 0, mastered = 0, next = null;
	for (const skill of SKILLS) {
		for (const entry of Object.values(deck[skill] || {})) {
			if (!entry) continue;
			if (entry.box >= MASTERED_BOX) mastered++;
			else if (entry.due <= now) due++;
			else {
				learning++;
				if (next === null || entry.due < next) next = entry.due;
			}
		}
	}
	return { due, learning, mastered, next };
}
